import { useSelector } from "react-redux";

export const useEffectiveStudentId = (): string  => {
  const user = useSelector((state: any) => state.authSlice.user);
  const selectedStudentId = useSelector((state: any) => state.student.selectedStudentId);

  if (user?.role === "guardian") {
    return selectedStudentId || "";
  }

  return user?.roleId || null;
};